export const generateRandomString = () =>
  Math.random().toString(36).substr(2, 10);
